import createCalendar from "../lib/ouical.js";

$(function() {
    var calendarEl = $('.hpa-calendar-wrapper');
    if (calendarEl.length) {
        var dateStart = new Date(calendarEl.data('timestamp-ms-start'));
        var calendarData = {
            data: {
                start: dateStart,
                duration: calendarEl.data('duration'),
                title: calendarEl.data('title'),
                description: calendarEl.data('description'),
                url: calendarEl.data('url'),
                downloadUrl: calendarEl.data('download-url'),
            }
        };

        calendarEl.append(createCalendar(calendarData));

        calendarEl.find('.hpa-calendar-btn').on('click', function(e) {
            e.preventDefault();
            var $this = $(this),
                calendarItems = calendarEl.find('.hpa-calendar-items');

            if (!$this.attr('disabled')) {
                $this.attr('disabled', true);
                if (calendarItems.is(':visible')) {
                    calendarItems.hide();
                    $this.removeAttr('disabled');
                } else {
                    calendarItems.show();
                    $this.removeAttr('disabled');
                }
            }

        });
    }
});



// WEBPACK FOOTER //
// ./js/modules/hpaCalendar.js